import React from 'react';

const CustomTile2 = ({ onClick, tileLogo, title, about }) => {
  return (
    <div className="inset-0 flex items-center justify-center">
      <div
        onClick={onClick} 
        className="w-96 h-56 rounded-10 bg-#dcb3b3 border-2 border-white-300 rounded-[10px] opacity-90 flex items-center justify-center cursor-pointer p-2"
        style={{ backgroundColor: '#171c8f' }}
      >
        <div className="bg-gradient-to-b rounded-[20px] w-96 h-56 flex items-center justify-center">
          <div className="bg-gradient-to-b from-white to-white rounded-[20px] w-31 h-50 flex items-center justify-center">
            <img
              src={tileLogo}
              alt="tile-logo"
              className={`object-cover w-full h-full rounded-[20px]`}
              style={{ width: '100%', height: '100%' }}
            />
          </div>
          <div className="ml-5">
            <p className="font-roboto font-semibold inline-block text-white text-xl">{title}</p>
            <br />
            <p className="font-roboto italic text-white text-sm leading-6 text-shadow inline whitespace-nowrap">{about}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomTile2;
